import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import UseModal from 'components/modal/useModal';
import { useEffect, useState } from 'react';
import {
  CardIdentity,
  CardVitale,
  CrossIcon,
  DocumentIcon,
  Localisation,
  SelfieIdentity,
} from '../../../../../../assets/icons';
import { dateToEpoch } from '../../../../../../helper/helper';
import UseContext from '../../../../../../hooks/useContext';
import Usefetchdata from '../../../../../../hooks/usefetchdata';
import ApiDatabase from '../../../../../../server';
import Button from '../../../../../button';
import Banner from '../../../../../banner/banner';
import { parseKycReason } from 'helper/kycDocumentReason';
import ModalBody from '../../../../components/body';
import ModalFooter from '../../../../components/footer';

// A refusal and a document merely waiting for a manual check used to share the same warning
// banner, so nothing on screen told them apart.
const BANNER_TYPE_BY_OUTCOME = {
  validated: 'info',
  pending: 'warning',
  rejected: 'alert',
  unknown: 'warning',
};

const AdminModalFileView = () => {
  const { toggle } = UseModal();
  const { adminType, adminTempWorkerId, adminUserId, adminFileName } =
    UseContext();
  const { userData } = Usefetchdata();
  const [isWaiting, setIsWaiting] = useState(true);
  const [tempWorkerInfos, setTempWorkerInfos] = useState({
    tempWorker: {},
    user: {},
  });
  const token = localStorage.getItem('xsrfToken');
  const [docs, setDocs] = useState([]);
  const [viewerStyle, setViewerStyle] = useState({
    maxHeight: 700,
    pdfVerticalScrollByDefault: true,
  });

  useEffect(() => {
    if (userData._id && adminUserId && adminType) {
      manageFiles();
    }
  }, [adminType, adminUserId, userData]);

  const manageFiles = () => {
    if (!adminUserId || !adminType) {
      setDocs([]);
      return;
    }

    setIsWaiting(true);

    ApiDatabase.postPresignFiles(
      {
        token,
        idUser: adminUserId,
        type: adminType,
        fileName: adminFileName || '',
      },
      (data) => {
        const urls = Array.isArray(data?.urls) ? data.urls : [];
        const docsFromLinks = urls.filter(Boolean).map((item) => {
          const href = item.url || item.uri || '';
          let originalFileName = '';
          try {
            const u = new URL(href);
            originalFileName = decodeURIComponent(
              (u.pathname.split('/').pop() || '').trim()
            );
          } catch (e) {
            const clean = href.split('?')[0].split('#')[0];
            originalFileName = decodeURIComponent(
              (clean.split('/').pop() || '').trim()
            );
          }
          return {
            uri: href,
            fileName: originalFileName || 'document',
            fileType: item.type || 'application/pdf',
          };
        });
        setIsWaiting(false);
        setDocs(docsFromLinks);
      },
      (err) => {
        console.log(err);
        setDocs([]);
        setIsWaiting(false);
      }
    );
  };

  const type = {
    identity: {
      text: "Pièce d'identité",
      icon: <CardIdentity wh={24} color={'#6B7280'} />,
    },
    selfie: {
      text: "Selfie d'identité",
      icon: <SelfieIdentity wh={24} color={'#6B7280'} />,
    },
    visa: {
      text: 'Visa',
      icon: <CardIdentity wh={24} color={'#6B7280'} />,
    },
    card_vitality: {
      text: 'Carte Vitalité',
      icon: <CardVitale wh={24} color={'#6B7280'} />,
    },
    proof_of_address: {
      text: 'Justificatif de domicile',
      icon: <Localisation wh={24} color={'#6B7280'} />,
    },
    accommodation_of_address: {
      text: 'Attestation de logement',
      icon: <Localisation wh={24} color={'#6B7280'} />,
    },
    hostIdentity: {
      text: "Pièce d'identité de l'hôte",
      icon: <CardIdentity wh={24} color={'#6B7280'} />,
    },
    cv: {
      text: 'CV',
      icon: <DocumentIcon wh={24} color={'#6B7280'} />,
    },
    otherDocument: {
      text: 'Autre Document',
      icon: <DocumentIcon wh={24} color={'#6B7280'} />,
    },
    payslip: {
      text: 'Fiche de paie',
      icon: <DocumentIcon wh={24} color={'#6B7280'} />,
    },
    licence: {
      text: 'Permis',
      icon: <DocumentIcon wh={24} color={'#6B7280'} />,
    },
    invoice: {
      text: 'Facture',
      icon: <DocumentIcon wh={24} color={'#6B7280'} />,
    },
  };

  useEffect(() => {
    if (userData._id) {
      if (token && adminTempWorkerId) {
        ApiDatabase.getTempWorkerById(
          { token, adminTempWorkerId },
          (data) => {
            setTempWorkerInfos((prevData) => ({
              ...prevData,
              tempWorker: data,
            }));
            const id_user = data.id_user;
            ApiDatabase.getUserById(
              { token, id_user },
              (data) => {
                const birthDay = dateToEpoch(data.birthday);
                setTempWorkerInfos((prevData) => ({
                  ...prevData,
                  user: {
                    ...data,
                    birthday:
                      ('0' + birthDay.getDate()).toString().slice(-2) +
                      '/' +
                      ('0' + (parseInt(birthDay.getMonth()) + 1))
                        .toString()
                        .slice(-2) +
                      '/' +
                      birthDay.getFullYear(),
                  },
                }));
              },
              (err) => {
                if (err.name !== 'CanceledError') {
                  console.log(err);
                }
              }
            );
          },
          (err) => {
            if (err.name !== 'CanceledError') {
              console.log(err);
            }
          }
        );
      }
    }
  }, [adminTempWorkerId, userData]);

  return (
    <>
      <ModalBody>
        <div className={'flex gap-3'}>
          <div className={adminTempWorkerId ? 'w-2/3' : 'w-full'}>
            {isWaiting ? (
              <div className="flex flex-col shadow border rounded-md p-6 space-y-6">
                <div className="flex items-center space-x-4">
                  <div className="h-20 w-20 skeleton-bar"></div>
                  <div className="flex-1 space-y-3">
                    <div className="h-5 w-1/3 skeleton-bar"></div>
                    <div className="h-4 w-1/4 skeleton-bar"></div>
                  </div>
                </div>

                <div className="space-y-2">
                  <div className="h-4 w-1/5 skeleton-bar"></div>
                  <div className="h-3 w-2/3 skeleton-bar"></div>
                  <div className="h-3 w-3/4 skeleton-bar"></div>
                  <div className="h-3 w-1/2 skeleton-bar"></div>
                </div>

                <div className="space-y-2">
                  <div className="h-4 w-1/4 skeleton-bar"></div>
                  <div className="h-3 w-2/3 skeleton-bar"></div>
                  <div className="h-3 w-3/4 skeleton-bar"></div>
                  <div className="h-3 w-1/2 skeleton-bar"></div>
                </div>

                <div className="space-y-2">
                  <div className="h-4 w-1/4 skeleton-bar"></div>
                  <div className="h-3 w-2/3 skeleton-bar"></div>
                  <div className="h-3 w-3/4 skeleton-bar"></div>
                  <div className="h-3 w-1/2 skeleton-bar"></div>
                </div>

                <div className="space-y-2">
                  <div className="h-4 w-1/4 skeleton-bar"></div>
                  <div className="h-3 w-2/3 skeleton-bar"></div>
                  <div className="h-3 w-3/4 skeleton-bar"></div>
                </div>

                <div className="space-y-2">
                  <div className="h-4 w-1/4 skeleton-bar"></div>
                  <div className="grid grid-cols-2 gap-2">
                    <div className="h-3 w-3/4 skeleton-bar"></div>
                    <div className="h-3 w-2/3 skeleton-bar"></div>
                    <div className="h-3 w-1/2 skeleton-bar"></div>
                    <div className="h-3 w-2/5 skeleton-bar"></div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {docs.length > 0 ? (
                  <DocViewer
                    documents={docs}
                    style={viewerStyle}
                    pluginRenderers={DocViewerRenderers}
                  />
                ) : (
                  <div
                    className={
                      'flex justify-center items-center h-full py-3 px-1 border rounded'
                    }
                  >
                    <div className={'text-gray-500'}>
                      Aucun document à afficher.
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          {adminTempWorkerId && (
            <div className={'w-1/3 flex flex-col gap-3'}>
              <div className={'w-full'}>
                <div className={'flex justify-between gap-5'}>
                  <div className={'w-full'}>
                    <div className={'p-3 border rounded flex gap-3'}>
                      <div className={'my-auto'}>{type[adminType]?.icon}</div>
                      <div className={'my-auto ft-sm'}>
                        <div className={''}>
                          {adminType === 'identity' &&
                            (tempWorkerInfos.tempWorker.identity?.type ===
                            'Passeport'
                              ? 'Passeport'
                              : "Carte d'identité")}
                          {adminType === 'visa' &&
                            (tempWorkerInfos.tempWorker.visa?.type === 'Visa'
                              ? 'Visa'
                              : 'Titre de séjour')}
                          {adminType !== 'identity' &&
                            adminType !== 'visa' &&
                            type[adminType].text}
                        </div>
                        <div className={'text-gray-500'}>
                          {docs.length === 2
                            ? 'Recto & verso'
                            : docs.length > 2
                            ? 'Plusieurs documents'
                            : 'Document unique'}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={''}>
                    <div className={'cursor-pointer'} onClick={toggle}>
                      <CrossIcon wh={20} color={'#374151'} />
                    </div>
                  </div>
                </div>
              </div>
              {/* Display reason if available */}
              {tempWorkerInfos.tempWorker[adminType]?.reason && (
                <div className={'w-full'}>
                  <Banner
                    type={
                      BANNER_TYPE_BY_OUTCOME[
                        parseKycReason(tempWorkerInfos.tempWorker[adminType]?.reason).outcome
                      ]
                    }
                  >
                    <div className="ft-sm">
                      <strong>Raison :</strong> {tempWorkerInfos.tempWorker[adminType]?.reason}
                    </div>
                  </Banner>
                </div>
              )}
            </div>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button size={'LG'} color={'PRIMARY'} onClick={toggle}>
          Fermer
        </Button>
      </ModalFooter>
    </>
  );
};

export default AdminModalFileView;
